<template>
      <div class="conf-con">
                            <div class="intro-pic">
                                <img src="../../../assets/images/16.jpg" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第十六次全国代表大会简介</p>
                            <p class="margin1">2002年11月8日至14日在北京举行。江泽民作《全面建设小康社会，开创中国特色社会主义事业新局面》的报告。大会提出全面建设小康社会的战略目标，把“三个代表”重要思想写入党章，与马克思列宁主义、毛泽东思想、邓小平理论一起作为党必须长期坚持的指导思想。大会通过了《关于十五届中央委员会报告的决议》、《关于〈中国共产党章程（修正案）〉的决议》和《关于中央纪律检查委员会工作报告的决议》。大会选举了由198名委员和158名候补委员组成的中央委员会，选举了由121名委员组成的中央纪律检查委员会。随后召开的十六届一中全会选举了中央政治局及其常务委员会；选举胡锦涛为中央委员会总书记；决定江泽民为中央军事委员会主席；批准吴官正为中央纪律检查委员会书记。</p>
                        </div>
</template>

<script>
export default {

}
</script>

<style>

</style>